import React, { useContext, useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Loader from '../../assets/imgs/loader.gif';
import { Modal, Button } from 'react-bootstrap';
import styles from './SkinAndTicketTransfer.module.scss';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import GoldTicketImg from '../../assets/imgs/ticket/gold_ticket_large.png';
import SilverTicketImg from '../../assets/imgs/ticket/silver_ticket_large.png';
import BronzeTicketImg from '../../assets/imgs/ticket/bronze_ticket_large.png';

import IconPolygonSmall from '../../assets/icons/icon-polygon.png';
import IconSuccess from '../../assets/imgs/bridge/icon-success.png';
import IconCopy from '../../assets/icons/icon-copy.png';
import IconTransfer from '../../assets/icons/icon_transfer.png';
import arrowDown from '../../assets/icons/icon-arrow-down.svg';

import { TokenContext, TYPES, ABIContext } from '../Context';
import { middleEllipsis, copyToClipboard } from '../../helpers';
import { allTokenTypes, toCamelCase } from '../Skins/utils';
import { toBN } from 'web3-utils';
import { Web3Context } from '../../web3';


const SkinAndTicketTransfer = (props) => {
    const { t } = useTranslation();
    const history = useHistory();
    const [state, dispatch] = useContext(TokenContext);
    const [abiConfig, abiDispatch] = useContext(ABIContext);
    const [transferState, setTransferState] = useState('start');
    const [errorMsg, setErrorMsg] = useState('');
    const [transferAmount, setTransferAmount] = useState(0);
    const [receiverAddr, setReceiverAddr] = useState('');
    const [transferTxnHash, setTransferTxnHash] = useState('');
    const [transferBtnEnabled, setTransferBtnEnabled] = useState(false);
    const { web3, showTransferModal, setShowTransferModal, skinImage, skinTypeForTransfer, mapImage, mapId, mapTypeForTransfer, tokenTypeForTransfer, maxTokenCount, switchNetwork, PolygonNetworkInfo } = props;
    const { selectedAccount, networkId } = useContext(Web3Context);
    const {
        skinAndTicket: {
            polygonTowerInventoryContract,
        }
    } = abiConfig;

    const polygonScanBaseUrl = 'https://polygonscan.com/tx/';

    const handleMaxBtnClick = () => {
        setTransferAmount(maxTokenCount);
    }

    const handleWalletAddressChange = (event) => { 
        setReceiverAddr(event.target.value);
    }

    const handleChange = (e) => {
        const format = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>\/?A-Za-z]+/;
        setTransferAmount(parseInt(e.target.value));
        if(maxTokenCount < parseInt(e.target.value)) {
            (tokenTypeForTransfer && setErrorMsg(`No. of tickets cannot exceed ${maxTokenCount}`));
            (skinTypeForTransfer && setErrorMsg(`No. of skins cannot exceed ${maxTokenCount}`));
            (mapTypeForTransfer && setErrorMsg(`No. of maps cannot exceed ${maxTokenCount}`));
        } else if(format.test(e.target.value)) {
            setErrorMsg('Amount must be a positive integer greater than 0');
        } else {
            setErrorMsg('');
        }
    }

    const handleOkBtnClick = () => {
        setShowTransferModal(false);
        setTransferState('reset');
        (tokenTypeForTransfer && history.push('/inventory/tickets'));
        (skinTypeForTransfer && history.push('/inventory/skins'));
        (mapTypeForTransfer && history.push('/inventory/maps'));
    }

    const handleClipBoardClick = () => {
        copyToClipboard(receiverAddr);
    }
    
    const renderTicketImage = (tokenTypeForTransfer) => {
        return(
            <>
            {(tokenTypeForTransfer === 'Gold') && <img width="118px" height="80px" src={GoldTicketImg} />}
            {(tokenTypeForTransfer === 'Silver') && <img width="118px" height="80px" src={SilverTicketImg} />}
            {(tokenTypeForTransfer === 'Bronze') && <img width="118px" height="80px" src={BronzeTicketImg} />}
            </>
        )
    }

    const renderSkinImage = (image) => {
        return(
            <>
                {(skinTypeForTransfer) && (image) && <img width="118px" height="80px" src={image} />}
                {(mapTypeForTransfer) && (image) && <img width="122px" height="110px" src={image} />}
            </>
        )
    }

    const renderTransferForm = () => {
        return(
            <>
                <div className={(tokenTypeForTransfer !== undefined) ? styles.ticket_img_wrapper : styles.skin_img_wrapper}>
                    <div className={(tokenTypeForTransfer !== undefined) ? styles.ticket_img : styles.skin_img}>
                        { tokenTypeForTransfer && renderTicketImage(tokenTypeForTransfer) }
                        { skinTypeForTransfer && renderSkinImage(skinImage) }
                        { mapTypeForTransfer && renderSkinImage(mapImage) }
                    </div>
                    <div className={styles.polygon_img}>
                        <img width="20px" height="20px" src={IconPolygonSmall} />
                    </div>
                </div>

                <div className={styles.description}>
                    {(tokenTypeForTransfer !== undefined) && `Send ${tokenTypeForTransfer} Ticket to the below address`}
                    {(skinTypeForTransfer !== undefined) && `Send ${skinTypeForTransfer} Skin to the below address`}
                    {(mapTypeForTransfer !== undefined) && `Send ${mapTypeForTransfer} to the below address`}
                </div>

                <div className={styles.amount_wrapper}>
                    <div className={styles.amount_text}>
                        {'Amount'}
                    </div>
                    <div className={styles.amount_input_wrapper}>
                        <div>
                            <input type="number" 
                                className={styles.amount_input}
                                onChange={handleChange} value={transferAmount}
                                onKeyDown={(evt) => 
                                    (evt.key === "e" || evt.key === "E" || evt.key === ".") && evt.preventDefault()
                                } />
                        </div>
                        
                        <div className={styles.max_btn} onClick={handleMaxBtnClick}>{'MAX'}</div>
                    </div>
                    <div className={styles.available_balance_wrapper}>
                        <div className={styles.available_amount}>
                            <span>{`Available Balance: ${maxTokenCount}`}</span>
                        </div>
                        <div className={styles.error_msg}>
                            <span>{errorMsg}</span>
                        </div>
                    </div>
                </div>

                <div className={styles.down_arrow}>
                    <img src={arrowDown} width="16px" height="16px" />
                </div>

                <div className={styles.address_wrapper}>
                    <div className={styles.receiver_wallet_text}>
                        {`Receiver's wallet address`}
                    </div>
                    <div className={styles.receiver_wallet_address_wrapper}>
                        <input type="text" className={styles.receiver_wallet_address} onChange={handleWalletAddressChange} value={receiverAddr} />
                    </div>
                </div>

                {networkId !== 137 && networkId !== 80001 &&
                    <div className={styles.switch_network_wrapper}>
                        <span className={styles.switch_text}>{'Wrong network! Please switch to Polygon network for transferring tokens'}</span>
                    </div>
                }

                <div>
                    { (networkId === 137 || networkId === 80001) && <Button
                        className={`${styles.transfer_btn} ${!transferBtnEnabled ? styles.transfer_btn_grayed : ''}`} 
                        onClick={() => {
                            (tokenTypeForTransfer !== undefined)
                                ? initiateTicketTransfer(tokenTypeForTransfer, transferAmount) 
                                : 
                                    (skinTypeForTransfer !== undefined) 
                                        ? initiateSkinTransfer(skinTypeForTransfer, transferAmount)
                                        : initiateMapTransfer(mapId, transferAmount);
                            }
                        }>
                        <div className={styles.transfer_icon}>
                            <img width="24" src={IconTransfer} />
                        </div>
                        <div className={styles.transfer_text}>
                            {'Transfer'}
                        </div>
                    </Button> }
                </div>
            </>
        )

    }

    const renderTransferInProgress = () => {
        return (
            <>
                <div className={styles.transfer_in_progress}>
                    {'Transfer in Progress'}
                </div>
                <div className={styles.transfer_in_progress_loader}>
                    <img src={Loader} width="120px" height="120px" />
                </div>
                <div className={styles.processing}>
                    {t('PROCESSING')}
                </div>
                <div className={styles.processing_msg}>
                    {'Please CONFIRM to complete the transaction'}
                </div>
            </>
        )
    }

    const renderTransferCompleted = () => {
        return (
            <>
                <div className={styles.transfer_completed_img_wrapper}>
                    <div className={(tokenTypeForTransfer !== undefined) ? styles.transfer_completed_ticket_img : styles.transfer_completed_skin_img}>
                        { (tokenTypeForTransfer !== undefined) && renderTicketImage(tokenTypeForTransfer) }
                        { (skinTypeForTransfer !== undefined) && renderSkinImage(skinImage) }
                        { (mapTypeForTransfer !== undefined) && renderSkinImage(mapImage) }
                    </div>
                    <div className={styles.polygon_img}>
                        <img width="20px" height="20px" src={IconPolygonSmall} />
                    </div>
                </div>
                <div className={styles.transfer_completed_check_box_wrapper}>
                    <img width="80px" height="80px" src={IconSuccess} />
                </div>

                <div className={styles.transfer_completed_success_msg}>
                    {(tokenTypeForTransfer !== undefined) && `${tokenTypeForTransfer} (x${transferAmount}) ticket(s) successfully transferred to receiver Polygon wallet address`}
                    {(skinTypeForTransfer !== undefined) && `${skinTypeForTransfer} (x${transferAmount}) skin(s) successfully transferred to receiver Polygon wallet address`}
                    {(mapTypeForTransfer !== undefined) && `${mapTypeForTransfer} (x${transferAmount}) successfully transferred to receiver Polygon wallet address`}
                </div>

                <div className={styles.transfer_completed_network_address}>
                    <div className={styles.transfer_completed_network_logo_wrapper}>
                        <img src={IconPolygonSmall} width="21px" height="18px" />
                    </div>
                    <div className={styles.transfer_completed_network_name}>
                        <div className={styles.transfer_completed_network_text}>
                            {'Network'}
                        </div>
                        <div className={styles.transfer_completed_polygon_text}>
                            {'Polygon'}
                        </div>
                    </div>
                    <div className={styles.transfer_completed_line}> 
                    </div>
                    <div className={styles.transfer_completed_receiver_address}>
                        {middleEllipsis(receiverAddr)}
                    </div>
                    <div className={styles.transfer_completed_clipboard_icon}>
                        <img src={IconCopy} width="24px" height="24px" onClick={() => handleClipBoardClick()}/>
                    </div>

                </div>
                <a target="_blank" href={`${polygonScanBaseUrl}${transferTxnHash}`}>
                    <div className={styles.polygon_scan_link}>
                        <div className={styles.polygon_logo}>
                            <img src={IconPolygonSmall} width="20px" height="18px" />
                        </div>
                        <div className={styles.view_on_polygonscan} >
                            {t('VIEW_POLYSCAN')}
                        </div>
                    </div>
                </a>

                <div>
                    <Button className={styles.ok_btn} onClick={() => handleOkBtnClick()}>
                        <span className={styles.ok_btn_text}>{'OK'}</span>
                    </Button>
                </div>
            </>
        );
    }

    const renderTransferCanceled = () => {
        return (
            <>
                <div className={styles.transfer_canceled}>{t('TRANSACTION_CANCEL')}</div>
                <Button className={styles.ok_btn} onClick={() => handleOkBtnClick()}>
                    <span className={styles.ok_btn_text}>{t('OK')}</span>
                </Button>
            </>
        )
    }

    const renderTransferFailed = () => {
        return (
            <>
                <div className={styles.transfer_canceled}>{t('TRANSACTION_FAIL')}</div>
                <Button className={styles.ok_btn} onClick={() => handleOkBtnClick()}>
                    <span className={styles.ok_btn_text}>{t('OK')}</span>
                </Button>
            </>
        )
    }

    const initiateTicketTransfer = async (tokenType, transferAmt) => {
        try {
            if(transferAmt) {
                const tokenStrArr = tokenType.split(" ");
                const tokenTypeCamelCase = toCamelCase(tokenStrArr);
                setTransferState('inprogress');
                
                // fetch the token type from allTokenTypes
                let ticketTypeForTransfer;
                Object.keys(allTokenTypes).forEach(key => {
                    if(allTokenTypes[key] === tokenTypeCamelCase) {
                        ticketTypeForTransfer = key;
                    }
                });
                
    
                let gasPrice = await web3.eth.getGasPrice();
                let gasPriceBN = toBN(gasPrice);
                let finalGasPrice = gasPriceBN.add(toBN(parseInt(0.1 * gasPriceBN))).toString();
                let gasEstimate = await polygonTowerInventoryContract.methods.safeTransferFrom(selectedAccount, receiverAddr, ticketTypeForTransfer, transferAmount, "0x00").estimateGas({from: selectedAccount});
    
                let transferTxnResult = await polygonTowerInventoryContract.methods.safeTransferFrom(selectedAccount, receiverAddr, ticketTypeForTransfer, transferAmount, "0x00").send({
                    from: selectedAccount,
                    gasLimit: gasEstimate,
                    gasPrice: finalGasPrice
                });
    
                if(transferTxnResult.status === true && transferTxnResult.transactionHash) {
                    setTransferTxnHash(transferTxnResult.transactionHash);
                    setTransferState('completed');
                }
            }
        } catch(e) {
            console.log(`Error is: ${e}`);
            if(e.code !== 4001) {
                setTransferState('failed');
            } else {
                setTransferState('canceled');
            }
        }
    }

    const initiateSkinTransfer = async (tokenType, transferAmt) => {
        try {
            if(transferAmt) {
                // should we metamask transfer here
                const tokenStrArr = tokenType.split(" ");
                const tokenTypeCamelCase = toCamelCase(tokenStrArr);
                setTransferState('inprogress');
                
                let skinTypeForTransfer;
                // fetch the token type from allTokenTypes
                Object.keys(allTokenTypes).forEach(key => {
                    if(allTokenTypes[key] === tokenTypeCamelCase) {
                        skinTypeForTransfer = key;
                    }
                });
    
                let gasPrice = await web3.eth.getGasPrice();
                let gasPriceBN = toBN(gasPrice);
                let finalGasPrice = gasPriceBN.add(toBN(parseInt(0.1 * gasPriceBN))).toString();
                let gasEstimate = await polygonTowerInventoryContract.methods.safeTransferFrom(selectedAccount, receiverAddr, skinTypeForTransfer, transferAmount, "0x00").estimateGas({from: selectedAccount});
    
                let transferTxnResult = await polygonTowerInventoryContract.methods.safeTransferFrom(selectedAccount, receiverAddr, skinTypeForTransfer, transferAmount, "0x00").send({
                    from: selectedAccount,
                    gasLimit: gasEstimate,
                    gasPrice: finalGasPrice
                });
                if(transferTxnResult.status === true && transferTxnResult.transactionHash) {
                    setTransferTxnHash(transferTxnResult.transactionHash);
                    setTransferState('completed');
                }
            }
        } catch(e) {
            console.log(`Error is: ${e}`);
            if(e.code !== 4001) {
                setTransferState('failed');
            } else {
                setTransferState('canceled');
            }
        }
        
    }

    const initiateMapTransfer = async (mapId, transferAmt) => {
        try {
            if(transferAmt) {
                setTransferState('inprogress');
                
                let gasPrice = await web3.eth.getGasPrice();
                let gasPriceBN = toBN(gasPrice);
                let finalGasPrice = gasPriceBN.add(toBN(parseInt(0.1 * gasPriceBN))).toString();
                let gasEstimate = await polygonTowerInventoryContract.methods.safeTransferFrom(selectedAccount, receiverAddr, mapId, transferAmount, "0x00").estimateGas({from: selectedAccount});
                console.log("Gas estimate is: ", {gasEstimate, polygonTowerInventoryContract});
                let transferTxnResult = await polygonTowerInventoryContract.methods.safeTransferFrom(selectedAccount, receiverAddr, mapId, transferAmount, "0x00").send({
                    from: selectedAccount,
                    gasLimit: gasEstimate,
                    gasPrice: finalGasPrice
                });
                if(transferTxnResult.status === true && transferTxnResult.transactionHash) {
                    setTransferTxnHash(transferTxnResult.transactionHash);
                    setTransferState('completed');
                }
            }
        } catch(e) {
            console.log(`Error is: ${e}`);
            if(e.code !== 4001) {
                setTransferState('failed');
            } else {
                setTransferState('canceled');
            }
        }
        
    }

    useEffect(() => {
        try {
            if(networkId === 137 || networkId === 80001) {
                const address = web3.utils.toChecksumAddress(receiverAddr);
                if(address.length == 42 && errorMsg === '' && transferAmount > 0 && receiverAddr !== '') {
                    setTransferBtnEnabled(true);
                }
                else {
                    setTransferBtnEnabled(false);
                }
            } else {
                setTransferBtnEnabled(false);
            }
            
        } catch(e) {
            console.log(`${e}`);
            setTransferBtnEnabled(false);
        }
    }, [ receiverAddr, transferAmount, networkId ])

    return (
        <Modal show={showTransferModal} className={styles.bridge_modal} centered onHide={() => setShowTransferModal(false)}>
            <Modal.Header className={styles.bridge_modal_header}>
                <div className={styles.close_btn} onClick={() => {setShowTransferModal(false); (tokenTypeForTransfer !== undefined) ? history.push("/inventory/tickets") : (skinTypeForTransfer !== undefined) ? history.push("/inventory/skins") : history.push("/inventory/maps")}}>
                    <FontAwesomeIcon icon={faTimes} />
                </div>
            </Modal.Header>

            <Modal.Body className={styles.bridge_modal_body}>
                {transferState === 'start' && renderTransferForm()}
                {transferState === 'inprogress' && renderTransferInProgress()}
                {transferState === 'completed' && renderTransferCompleted()}
                {transferState === 'canceled' && renderTransferCanceled()}
                {transferState === 'failed' && renderTransferFailed()}
            </Modal.Body>
        </Modal>
    )
}

export { SkinAndTicketTransfer }
